/**
 * PATH: apps/hr/src/pages/settings/TagManagementPage.tsx
 * PURPOSE: HR tag management settings (real-data only)
 *
 * WHY:
 * - The previous implementation used mock tag data/services.
 * - Tag management is not yet backed by a real HR API in this hub.
 */

import { Tag } from 'lucide-react'
import { EmptyState } from '../../components/ui/EmptyState'

export function TagManagementPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">Tag Management</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
          Configure tags for HR documents and employees.
        </p>
      </div>

      <EmptyState
        icon={Tag}
        title="Tag management not connected"
        description="This page has been cleaned up to remove dummy data. Once a tags API is available for HR Hub, tag configuration will appear here."
      />
    </div>
  )
}

export default TagManagementPage

